import { useProjects } from '@servicetim/ui/api';
import { Button, Page, PageHeader } from '@servicetim/ui/components';
import { useNavigate } from '@tanstack/react-router';
import { Plus } from 'lucide-react';
import { useMemo, useState } from 'react';
import { ImportsTable } from './imports-table';
import { NewImportWizard } from './new-import-wizard';

/** `/imports` (S-09-10): the list of import batches and the "New import" wizard. */
export function ImportsScreen() {
  const navigate = useNavigate();
  const [wizardOpen, setWizardOpen] = useState(false);
  const projects = useProjects({ pageSize: 200 });
  const projectsById = useMemo(
    () => new Map(projects.items.map((p) => [p.id, p])),
    [projects.items],
  );

  return (
    <Page>
      <PageHeader
        title="Imports"
        description="Bring in tickets from Jira Service Management, Monday.com or a CSV file, with field mapping and a dry-run report before anything is written."
        actions={
          <Button onClick={() => setWizardOpen(true)}>
            <Plus />
            New import
          </Button>
        }
      />
      <ImportsTable
        projectsById={projectsById}
        onOpen={(batch) =>
          void navigate({ to: '/imports/$importId', params: { importId: batch.id } })
        }
      />
      <NewImportWizard
        open={wizardOpen}
        onOpenChange={setWizardOpen}
        projects={projects.items}
        onCreated={(importId) => void navigate({ to: '/imports/$importId', params: { importId } })}
      />
    </Page>
  );
}
